/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Ptw100InternalArea = {
    Area1: 'Area1',
    Area2: 'Area2',
    Area3: 'Area3'
} as const;
export type Ptw100InternalArea = typeof Ptw100InternalArea[keyof typeof Ptw100InternalArea];


export function Ptw100InternalAreaFromJSON(json: any): Ptw100InternalArea {
    return Ptw100InternalAreaFromJSONTyped(json, false);
}

export function Ptw100InternalAreaFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ptw100InternalArea {
    return json as Ptw100InternalArea;
}

export function Ptw100InternalAreaToJSON(value?: Ptw100InternalArea | null): any {
    return value as any;
}

/**
 * Check if a given object implements the Ptw100InternalArea interface.
 */
 export function instanceOfPtw100InternalArea(value: any): value is Ptw100InternalArea {
    return Object.values(Ptw100InternalArea).includes(value)
}

